import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BubbleMenu from "./BubbleMenu";

const NAV_SLOT_ROTATIONS = [-8, 6, -6, 8, 7, -7, 9, -9];

const NAV_ITEMS = [
  { label: "home", href: "/", ariaLabel: "Home", hoverStyles: { bgColor: "#3b82f6", textColor: "#ffffff" } },
  { label: "resources", href: "/resources", ariaLabel: "Resources", hoverStyles: { bgColor: "#14b8a6", textColor: "#ffffff" } },
  { label: "subjects", href: "/subjects", ariaLabel: "Subjects", hoverStyles: { bgColor: "#06b6d4", textColor: "#ffffff" } },
  { label: "articles", href: "/articles", ariaLabel: "Articles", hoverStyles: { bgColor: "#10b981", textColor: "#ffffff" } },
  { label: "tutors", href: "/tutors", ariaLabel: "Tutors", hoverStyles: { bgColor: "#f59e0b", textColor: "#ffffff" } },
  { label: "about", href: "/about", ariaLabel: "About", hoverStyles: { bgColor: "#ef4444", textColor: "#ffffff" } },
  { label: "faq", href: "/qa", ariaLabel: "FAQ", hoverStyles: { bgColor: "#8b5cf6", textColor: "#ffffff" } },
  { label: "contact", href: "/contact", ariaLabel: "Contact", hoverStyles: { bgColor: "#ec4899", textColor: "#ffffff" } },
].map((item, index) => ({ ...item, rotation: NAV_SLOT_ROTATIONS[index] }));

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isLightPage = normalizedPath === "/";

  const logoSrc = isLightPage ? "/logo1-80.png" : "/logo2-80.png";
  const logoFullSrc = isLightPage ? "/logo1.png" : "/logo2.png";
  const logo = useMemo(() => (
    <img
      src={logoSrc}
      srcSet={`${logoSrc} 80w, ${logoFullSrc} 373w`}
      sizes="(min-width: 768px) 36px, 31px"
      width="36"
      height="27"
      alt="ibcalculator"
      className="bubble-logo"
      decoding="async"
      fetchPriority="high"
    />
  ), [logoFullSrc, logoSrc]);
  const handleLogoClick = useCallback(() => {
    navigate("/");
  }, [navigate]);
  const handleNavigate = useCallback((href) => {
    navigate(href);
  }, [navigate]);

  return (
    <BubbleMenu
      logo={logo}
      items={NAV_ITEMS}
      menuBg={isLightPage ? "#ffffff" : "#1c1c1e"}
      menuContentColor={isLightPage ? "#111111" : "#ffffff"}
      useFixedPosition={true}
      menuAriaLabel="Toggle navigation"
      onLogoClick={handleLogoClick}
      onNavigate={handleNavigate}
    />
  );
}
